// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-range {
  --bar-height: 12px;
  --bar-border-radius: 16px;
}

ion-range::part(bar-active) {
  background: rgb(18, 133, 191);
}

ion-range::part(knob) {
  background: rgb(18, 133, 191);
}

.hide-knob::part(knob) {
  display: none;
}

.hide-knob::part(bar-active) {
  background: #0099ff;
  height: 10px;
  margin-left: 2px;
}

.hide-knob::part(bar) {
  border: 1px solid #0099ff;
  background: white;
}

.hide-knob-container {
  pointer-events: none;
  cursor: not-allowed;
}

.range-container {
  display: flex;
  font-family: var(--font-primary);
  column-gap: 6px;
}
.range-container span {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-style: normal;
  font-weight: 700;
  font-size: 9px;
  line-height: 9px;
  transform: translateY(2px);
  color: var(--ion-color-dark);
}`, "",{"version":3,"sources":["webpack://./src/app/components/rewards-components/reward-slider/reward-slider.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,yBAAA;AACJ;;AAEA;EACI,6BAAA;AACJ;;AAEA;EACI,6BAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,mBAAA;EACA,YAAA;EACA,gBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,oBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,gCAAA;EACA,eAAA;AACJ;AAAI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,0BAAA;EACA,4BAAA;AAER","sourcesContent":["ion-range {\n    --bar-height: 12px;\n    --bar-border-radius: 16px;\n}\n\nion-range::part(bar-active) {\n    background: rgba(18, 133, 191, 1);\n}\n\nion-range::part(knob) {\n    background: rgba(18, 133, 191, 1);\n}\n\n.hide-knob::part(knob) {\n    display: none;\n}\n\n.hide-knob::part(bar-active) {\n    background: #0099ff;\n    height: 10px;\n    margin-left: 2px;\n}\n\n.hide-knob::part(bar) {\n    border: 1px solid #0099ff;\n    background: white\n}\n\n.hide-knob-container {\n    pointer-events: none;\n    cursor: not-allowed;    \n}\n\n.range-container {\n    display: flex;\n    font-family: var(--font-primary);\n    column-gap: 6px;\n    span {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        font-style: normal;\n        font-weight: 700;\n        font-size: 9px;\n        line-height: 9px;\n        transform: translateY(2px);\n        color: var(--ion-color-dark);\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
